import { useEffect } from "react";

import { Element } from "react-scroll";
import Seo from "../home/components/Seo";
import HeroSection from "../home/components/HeroSection";
import AboutSection from "../About/About";
import ServicesSection from "../home/components/ServicesSection";
import TradeSection from "../home/components/TradeSection";
import MembersSection from "../home/components/MembersSection";
import EventsSection from "../home/components/EventsSection";
import NewsSection from "../home/components/NewsSection";
import ActivitySection from "../home/components/ActivitySection";
import GallerySection from "../home/components/GallerySection";
import MembershipSection from "../home/components/MembershipSection";
import ContactSection from "../home/components/ContactSection";

export default function HomeIt() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 400);
    }
  }, []);

  return (
    <div className="relative">
      <Seo
        title="BICCI – Camera di Commercio e Industria Italia-Bangladesh"
        description="BICCI è una piattaforma bilaterale dedicata a rafforzare la cooperazione economica tra il Bangladesh e l'Italia. Scopri opportunità di investimento, commercio e collaborazione tra i due paesi."
        path="/"
        lang="it"
      />
      <main>
        <Element name="home">
          <HeroSection lang="it" />
        </Element>
        <Element name="about">
          <AboutSection lang="it" />
        </Element>
        <Element name="services">
          <ServicesSection />
        </Element>
        <Element name="trade">
          <TradeSection />
        </Element>
        <Element name="members">
          <MembersSection />
        </Element>
        <Element name="events">
          <EventsSection />
        </Element>
        <Element>
          <NewsSection />
        </Element>
        <Element name="activity">
          <ActivitySection />
        </Element>
        <Element name="gallery">
          <GallerySection />
        </Element>
        <Element name="membership">
          <MembershipSection />
        </Element>
        <Element name="contact">
          <ContactSection />
        </Element>
      </main>
    </div>
  );
}
